import React from 'react'

import useAuth from '../hooks/useAuth'
import ThumbnailLoader from '../components/ThumbnailLoader'

const WorkSpacePage: React.FC = () => {
  const loadingState = useAuth()

  return (
    <div className="App">
      <ThumbnailLoader loadingState={loadingState} />
    </div>
  )
}

export default WorkSpacePage
